exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".knowledge_16l8DLL1 {\n  background: #fff;\n  margin-top: 0.133333rem;\n}\n\n.knowledgeMd_3ZTYu9Y2 {\n  text-align: center;\n  padding: 0.533333rem 0 0.4rem;\n}\n\n.knowledgeMdImg_6dcetRnJ {\n  width: 3.386667rem;\n}\n\n.viewMore_LhD3cQop {\n  height: 1.066667rem;\n  line-height: 1.066667rem;\n  text-align: center;\n}\n\n.viewMoreBtn_3gbU7pc- {\n  height: 1.066667rem;\n  line-height: 1.066667rem;\n  font-size: 0.373333rem;\n  color: #212223;\n  padding-right: 0.426667rem;\n  background: url(https://x0.ifengimg.com/ucms/2020_43/910CBF602D45604729550B72E6AAA951274865B6_w24_h26.png) no-repeat\n        right center/0.32rem auto;\n}", ""]);

// exports
exports.locals = {
	"knowledge": "knowledge_16l8DLL1",
	"knowledgeMd": "knowledgeMd_3ZTYu9Y2",
	"knowledgeMdImg": "knowledgeMdImg_6dcetRnJ",
	"viewMore": "viewMore_LhD3cQop",
	"viewMoreBtn": "viewMoreBtn_3gbU7pc-"
};